import { get, once } from 'lodash';
import { connect } from 'react-redux';

import PdpSizeSelector from 'components/PdpSizeSelector';
import { INVENTORY_LEVELS } from 'components/PdpStoreInventory/constants';
import { TYPES } from 'constants/merchandising';
import * as actions from 'state/actions';
import { getCurrentProduct, getCurrentSize, getCurrentVariant } from 'state/selectors/pdp';
import Settings from 'utils/Settings';
import { StoreLocationUtils } from 'utils/StoreLocation';
import { WAREHOUSE_LOCATION_IDS } from 'utils/StoreLocation/constants';

const showLowInventoryUrgencyMessage = currentVarianParam => {
  let hasLowInventoryMessage = false;

  if (currentVarianParam && StoreLocationUtils.isInventoryAvailableOnSize(currentVarianParam)) {
    const inventoryNumericIds = StoreLocationUtils.mapShopifyLocationGraphqlIdToNumericId(
      currentVarianParam?.metafields
    );

    const warehouseIdListStrings = WAREHOUSE_LOCATION_IDS[Settings.shopID]?.map(String) || [];
    const warehouseInventory = Object.keys(inventoryNumericIds)
      .filter(key => warehouseIdListStrings.includes(key))
      .reduce((obj, key) => {
        obj[key] = inventoryNumericIds[key];
        return obj;
      }, {});
    const values = Object.values(warehouseInventory);

    const hasNoHighInventory = !values.includes(INVENTORY_LEVELS.HIGH_INVENTORY);
    const hasAtLeastOneLowInventory = values.includes(INVENTORY_LEVELS.LOW_INVENTORY);

    hasLowInventoryMessage = hasNoHighInventory && hasAtLeastOneLowInventory;
  }

  return hasLowInventoryMessage;
};

const isLowInventoryUrgencyMessageEnbled = currentShopId => {
  return Settings.lowInventoryUrgencyMessageGeosCsv?.includes(currentShopId) || false;
};

const mapStateToProps = (state, ownProps) => {
  const currentProduct = getCurrentProduct(state);
  const currentSize = getCurrentSize(state);
  const currentVariant = getCurrentVariant(state);

  const isBackordered = get(currentVariant, ['backordered']);
  const backorderMessage = isBackordered ? get(currentProduct, 'backorderMessage') : null;

  const productUpdatesTooltipEnabled =
    get(currentProduct, 'hasUnavailableSizes') && get(currentProduct, ['enableBackInStockEmail']);

  const isSoldOut = currentVariant && !get(currentVariant, ['available']);
  const soldOutMessage = isSoldOut ? get(currentProduct, ['soldOutMessage']) : null;

  const isFinalSale = Settings.finalSaleMessagingEnabled && get(currentProduct, ['isFinalSale']);

  const showUrgencyMessaging =
    showLowInventoryUrgencyMessage(currentVariant) &&
    !isSoldOut &&
    isLowInventoryUrgencyMessageEnbled(Settings.shopID) &&
    currentProduct.type !== TYPES.GIFT_CARDS;

  return {
    ...ownProps,
    product: currentProduct,
    sizes: currentProduct.sortedSizes,
    currentSize,
    backorderMessage,
    soldOutMessage,
    isFinalSale,
    productUpdatesTooltipEnabled,
    type: currentProduct.type,
    masterId: currentProduct.masterId,
    showUrgencyMessaging,
  };
};

const mapDispatchToProps = dispatch => ({
  selectSize: selectedSize => dispatch(actions.setCurrentSize(selectedSize)),
  trackProductUpdatesTooltipView: once(() => dispatch(actions.trackProductUpdatesTooltipView())),
});

export default connect(mapStateToProps, mapDispatchToProps)(PdpSizeSelector);
